<div class="Main_{{ Companyname }}" appDisabledRightClick>
  <!-- Done by pradnesh 22/04/2025 -->
  <div id="QRBoxId" class="QRBox" *ngIf="!IsMobile && IsShowHideQR"> <!-- && IsShowHideQR-->
    <img
      src="../../assets/images/FloatingQR1.jpg"
      alt="QRCode"
      (click)="OpenModalForAppQR()" />
  </div>

  <div *ngIf="IsShowHide" id="IsShowHideheader">
    <app-header></app-header>
  </div>
  <div *ngIf="IsShowHideIFAHeader" id="IsShowHideheader">
    <IFA-header></IFA-header>
  </div>
  <router-outlet></router-outlet>
</div>

<div class="modal" id="AlertModal" appDisabledRightClick>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message</div>
      <div id="AlertModalContent" class="modal-body AlertModalBody"></div>
      <div class="modal-footer AlertModalFooter">
        <button type="button" data-dismiss="modal" class="CursorPointer">
          Okay
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="AlertModal_Family" appDisabledRightClick>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message</div>
      <div
        id="AlertModalContent_Family"
        class="modal-body AlertModalBody"></div>
      <div class="modal-footer AlertModalFooter">
        <button type="button" data-dismiss="modal" class="CursorPointer">
          Okay
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="AlertLoginModal" appDisabledRightClick>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message</div>
      <div id="AlertLoginModalContent" class="modal-body AlertModalBody"></div>
      <div class="modal-footer AlertModalFooter">
        <button type="button" data-dismiss="modal" class="CursorPointer">
          Okay
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="SessionModal" appDisabledRightClick>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message</div>
      <div class="modal-body AlertModalBody">
        Your session has been expired.
      </div>
      <div class="modal-footer AlertModalFooter">
        <button
          *ngIf="Companyname != 'Kotak'"
          type="button"
          data-dismiss="modal"
          class="CursorPointer"
          routerLinkActive="active">
          Okay
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="CommonInfoModal" appDisabledRightClick>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message</div>
      <div
        id="InfoModalContent"
        class="modal-body AlertModalBody InfoModal"></div>
      <div class="modal-footer AlertModalFooter">
        <button type="button" data-dismiss="modal" class="CursorPointer">
          Okay
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="NotAuthmodal" appDisabledRightClick>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message</div>
      <div id="NotAuthmodalContent" class="modal-body AlertModalBody"></div>
      <div class="modal-footer AlertModalFooter">
        <button
          type="button"
          data-dismiss="modal"
          class="CursorPointer"
          routerLink="/employee-dashboard"
          routerLinkActive="active">
          Okay
        </button>
      </div>
    </div>
  </div>
</div>

<a
  *ngIf="Companyname != 'SPA'"
  href="javascript:"
  id="return-to-top"
  appDisabledRightClick>
  <img src="../{{ CommonBaseHref }}assets/images/icon-arrow-up.svg" />
</a>

<div *ngIf="Companyname != 'AU' && Loader.visible" appDisabledRightClick>
  <div
    class="overlay overlay_white"
    [ngClass]="Companyname == 'IFA' ? 'transparent' : ''">
    <img
      [src]="loader"
      [style.width]="loaderWidth"
      [style.height]="loaderHeight"
      style="background-color: #ffff; border-radius: 10px" />
  </div>
</div>

<div class="modal" id="AppQRModal" appDisabledRightClick>
  <div class="modal-dialog modal-dialog-centered">
    <div
      class="modal-content AlertModalContentCls"
      style="
        border-radius: 24px !important;
        min-width: 600px !important;
        height: 434px !important;
      ">
      <!-- Modal Header -->
      <!-- <div class="modal-header AlertModalHeader p-3" style="border-bottom: 0px !important;">
        <button type="button"  id="MandatecloseButton" class="close pt-2" data-dismiss="modal" aria-label="Close">&times;</button>
     </div> -->
      <div id="AppQRModalContent" class="modal-body AlertModalBody">
        <div class="align-items-end">
          <button
            type="button"
            id="MandatecloseButton"
            class="close"
            data-dismiss="modal"
            aria-label="Close">
            &times;
          </button>
        </div>
        <div class="text-center mb-2">
          <div
            style="
              color: #112626;
              font-size: 18px;
              margin-top: 50px;
              font-weight: 500;
            ">
            Get the Mobile App for a anytime, anywhere experience
          </div>
          <div
            style="color: #11262680; margin: 6px 0px 28px 0px; font-size: 14px">
            To download the app, scan the code or click on the badge
          </div>
        </div>
        <div *ngIf="!IsOptimoney">
          <div class="OptimoneyQRBlock">
            <ul>
              <li>
                <div>
                  <img
                    style="
                      height: 150px !important;
                      margin-bottom: 18px;
                      border-style: solid !important;
                      border: 1px #d5d5d5;
                      border-radius: 14px !important;
                    "
                    class="img-fluid"
                    alt="Optimum mobile app showcase"
                    [src]="UploadedQR" />
                </div>
              </li>
              <li>
                <a
                  class="item"
                  [href]="Googleplaylink"
                  target="_blank"
                  rel="do-follow">
                  <img
                    style="width: 150px !important; height: auto !important"
                    class="icon"
                    loading="lazy"
                    src="../../assets/images/img/googlePlay.png"
                    alt="play store icon" />
                </a>
              </li>
            </ul>
            <ul>
              <li>
                <div>
                  <img
                    style="
                      height: 150px !important;
                      margin-bottom: 18px;
                      border-style: solid !important;
                      border: 1px #d5d5d5;
                      border-radius: 14px !important;
                    "
                    class="img-fluid"
                    [src]="WhatsAppQR" />
                </div>
              </li>
              <li>
                <a
                  class="item"
                  [href]="WhatsAppLink"
                  target="_blank"
                  rel="do-follow">
                  <img
                    style="width: 150px !important; height: auto !important"
                    class="icon"
                    loading="lazy"
                    src="../../assets/images/img/ConnectOnWhatsApp.png"
                    alt="play store icon" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div *ngIf="IsOptimoney && !IsOptiWealth">
          <div class="OptimoneyQRBlock">
            <ul>
              <li>
                <div>
                  <img
                    style="
                      height: 150px !important;
                      margin-bottom: 18px;
                      border-style: solid !important;
                      border: 1px #d5d5d5;
                      border-radius: 14px !important;
                    "
                    class="img-fluid"
                    src="../../assets/images/img/Optimoney_IOSQR.jpg" />
                </div>
              </li>
              <li>
                <a
                  class="item"
                  href="https://apps.apple.com/in/app/optimoney-mutual-funds-app/id6470476406"
                  target="_blank"
                  rel="do-follow">
                  <img
                    class="icon"
                    loading="lazy"
                    style="width: 150px !important; height: auto !important"
                    src="../../assets/images/img/appStore.png"
                    alt="play store icon" />
                </a>
              </li>
            </ul>
            <ul>
              <li>
                <div>
                  <img
                    style="
                      height: 150px !important;
                      margin-bottom: 18px;
                      border-style: solid !important;
                      border: 1px #d5d5d5;
                      border-radius: 14px !important;
                    "
                    class="img-fluid"
                    src="../../assets/images/img/Optimoney_AndroidQR.jpg" />
                </div>
              </li>
              <li>
                <a
                  class="item"
                  href="https://play.google.com/store/apps/details?id=com.optimum.client"
                  target="_blank"
                  rel="do-follow">
                  <img
                    style="width: 150px !important; height: auto !important"
                    class="icon"
                    loading="lazy"
                    src="../../assets/images/img/googlePlay.png"
                    alt="play store icon" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div *ngIf="IsOptimoney && IsOptiWealth">
          <div class="OptimoneyQRBlock">
            <ul>
              <li>
                <div>
                  <img
                    style="
                      height: 150px !important;
                      margin-bottom: 18px;
                      border-style: solid !important;
                      border: 1px #d5d5d5;
                      border-radius: 14px !important;
                    "
                    class="img-fluid"
                    src="../../assets/images/img/Optiwealth_IOSQR.png" />
                </div>
              </li>
              <li>
                <a
                  class="item"
                  href="https://apps.apple.com/in/app/optiwealth/id6743156447"
                  target="_blank"
                  rel="do-follow">
                  <img
                    class="icon"
                    loading="lazy"
                    style="width: 150px !important; height: auto !important"
                    src="../../assets/images/img/appStore.png"
                    alt="play store icon" />
                </a>
              </li>
            </ul>
            <ul>
              <li>
                <div>
                  <img
                    style="
                      height: 150px !important;
                      margin-bottom: 18px;
                      border-style: solid !important;
                      border: 1px #d5d5d5;
                      border-radius: 14px !important;
                    "
                    class="img-fluid"
                    src="../../assets/images/img/Optiwealth_AndroidQR.png" />
                </div>
              </li>
              <li>
                <a
                  class="item"
                  href="https://play.google.com/store/apps/details?id=com.ofspl.financeapp"
                  target="_blank"
                  rel="do-follow">
                  <img
                    style="width: 150px !important; height: auto !important"
                    class="icon"
                    loading="lazy"
                    src="../../assets/images/img/googlePlay.png"
                    alt="play store icon" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="RedirectDashBoardModal" appDisabledRightClick>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message</div>
      <div
        id="RedirectDashBoardModalContent"
        class="modal-body AlertModalBody"></div>
      <div class="modal-footer AlertModalFooter">
        <button
          type="button"
          data-dismiss="modal"
          class="CursorPointer"
          (click)="RedirectTODashBoard()">
          Okay
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="Delete" appDisabledRightClick>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message</div>
      <div id="MandateAlertModalContent" class="modal-body AlertModalBody">
        Are you sure you want to delete your account?
        <br />
        By deleting your account, all your data will be deleted from this app
        and you will not be able to log in to this App. Please note that your
        Mutual Investment Data can be accessed externally by visiting the
        respective Mutual Fund Asset Management Company's website.
      </div>
      <div class="modal-footer AlertModalFooter">
        <button
          type="button"
          data-dismiss="modal"
          class="CommonSecondaryButton CursorPointer"
          (click)="OnDelete()">
          Delete Account
        </button>
        <button
          type="button"
          data-dismiss="modal"
          class="CursorPointer"
          routerLink="/client-dashboard"
          routerLinkActive="active"
          (click)="closeNav()">
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="SureDelete" appDisabledRightClick>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message</div>
      <div id="MandateAlertModalContent" class="modal-body AlertModalBody">
        Account Deletion Request placed successfully.
        <br />
        Our system will send you an email to complete the process.
      </div>
      <div class="modal-footer AlertModalFooter">
        <button
          type="button"
          data-dismiss="modal"
          class="CursorPointer"
          routerLink="/login/investor"
          routerLinkActive="active">
          Okay
        </button>
      </div>
    </div>
  </div>
</div>
